import { render, staticRenderFns } from "./Points.vue?vue&type=template&id=51639818&scoped=true"
import script from "./Points.vue?vue&type=script&lang=js"
export * from "./Points.vue?vue&type=script&lang=js"
import style0 from "./Points.vue?vue&type=style&index=0&id=51639818&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51639818",
  null
  
)

export default component.exports